import { useDocumentTitle } from "../../hooks";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import MenuItemUser from "../../components/admin/menu/MenuItemUser";
import UserMasterLayout from "../../layouts/UserMasterLayout";
import { getUserTopPageSettings }from "../../api/setting/userMasterPageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import {
  clearPageLoading
} from '../../store/actions';
import {USER_MASTER_TOP_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";
import {RedirectAlert} from "../../components";

const UserTopPage = () => {
  useRedirectPage(USER_MASTER_TOP_PAGE);
  const [menuItems, setMenuItems] = useState([]);
  const dispatch = useDispatch();
  useDocumentTitle("TOP - ユーザーマスタ");

  useEffect(() => {
    const response = getUserTopPageSettings();
    const pageSettings = response.data;
    dispatch(setPageSettings(pageSettings));
    dispatch(clearPageLoading());
    setMenuItems(pageSettings.menu_items);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <UserMasterLayout breadcrumb={{}} page='top'>
      <div className="mt-[16px]">
        <RedirectAlert />
      </div>
      <div className="grid grid-cols-3 gap-x-8 gap-y-8 xl:gap-y-10 px-5 py-10 lg:px-8 lg:py-20 xl:px-40 xl:py-24 2xl:px-48 2xl:py-28 max-w-[1460px] mx-auto">
        {menuItems.map((item, index) => (
          <MenuItemUser key={index} menu={item.name}/>
        ))}
      </div>
    </UserMasterLayout>
  );
};

export default UserTopPage;